import { Button, Form } from 'antd'

import Breadcrumb from 'component/breadcrumb/breadcrumb'
import { BREADCRUMBS } from 'constants/breadcrumb'
import useCreatePTO from 'hooks/pto/use-create-pto'
import BaseInformation from 'modules/pto/form/base-information'
import CoTrustedPartners from 'modules/pto/form/co-trusted-partners'
import MetadataNFT from 'modules/pto/form/metadata-nft'
import Properties from 'modules/pto/form/properties'
import RentalInformation from 'modules/pto/form/rental-information'
import Timelines from 'modules/pto/form/timelines'
import UploadFile from 'modules/pto/form/upload-file'
import { notifyFormErrors } from 'utils/form-errors'

import './style.scss'

const CreatePTO = () => {
  const additionalItems = [BREADCRUMBS.PTO, BREADCRUMBS.PTO_CREATE_NO_LINK]
  const [form] = Form.useForm()

  const {
    thumbnail,
    setThumbnail,
    thumbnails,
    setThumbnails,
    propertyTypes,
    isSubmitting,
    handleSubmit,
    handleCancel,
  } = useCreatePTO({ form })

  return (
    <div className="p2p-create">
      <Breadcrumb additionalItems={additionalItems} />
      <Form
        form={form}
        layout="vertical"
        initialValues={{ remember: true }}
        style={{ padding: '20px 10px' }}
        onFinish={handleSubmit}
        onFinishFailed={notifyFormErrors}
        scrollToFirstError={{
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        }}
      >
        <BaseInformation form={form} edit={true} mode="create" />

        <Properties form={form} edit={true} propertyTypes={propertyTypes} mode="create" />

        <RentalInformation form={form} edit={true} mode="create" />

        <Timelines form={form} edit={true} mode={'create'} />

        <MetadataNFT form={form} edit={true} mode="create" />

        <UploadFile
          edit={true}
          form={form}
          defaultThumbnail={thumbnail}
          defaultThumbnails={thumbnails}
          onUpload={(data) => {
            setThumbnail(data)
          }}
          onUploadMulti={(data) => {
            setThumbnails(data)
          }}
        />

        <CoTrustedPartners form={form} edit={true} mode="create" />

        <div style={{ textAlign: 'center', paddingBottom: 5 }}>
          <Button style={{ marginRight: 15 }} key="back" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            disabled={
              thumbnail.length === 0 ||
              thumbnails.length === 0 ||
              isSubmitting ||
              form.getFieldsError().some(({ errors }) => errors.length > 0)
            }
            key="submit"
            type="primary"
            htmlType="submit"
            loading={isSubmitting}
          >
            Create
          </Button>
        </div>
      </Form>
    </div>
  )
}

export default CreatePTO
